import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PerfectScrollbarModule } from '@laurentgoudet/ngx-perfect-scrollbar';
import { CalloutModule } from '@shared/ui/callout/callout.module';

import { OnlineStatusModule } from '../online-status/online-status.module';
import { AlertComponent } from './alert/alert.component';
import { BudgetComponent } from './budget.component';
import { ButtonComponent } from './button/button.component';
import { CardComponent } from './card/card.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { ContainerComponent } from './container/container.component';
import { CurrencyComponent } from './currency/currency.component';
import {
  CardContentComponent,
  CardFooterLeftComponent,
  CardFooterRightComponent,
  CardHeaderLeftComponent,
  CardHeaderRightComponent,
  DisplayCardComponent,
} from './display-card/display-card.component';
import { EarningsComponent } from './earnings/earnings.component';
import { EllipsisTextComponent } from './ellipsis-text/ellipsis-text.component';
import { EmojiPickerComponent } from './emoji-picker/emoji-picker.component';
import { EmojiPipe } from './emoji/emoji.pipe';
import { FileDragDropComponent } from './file-drag-drop/file-drag-drop.component';
import { FlagComponent } from './flag/flag.component';
import { HighlightTextModule } from './highlight-text/highlight-text.module';
import { IconModule } from './icon/icon.module';
import { InputComponent } from './input/input.component';
import { LayoutModule } from './layout/layout.module';
import { LinkModule } from './link/link.module';
import { ListItemComponent } from './list-item/list-item.component';
import { LoadingTextComponent } from './loading-text/loading-text.component';
import { LocalizedDateFns } from './localized-date-fns.service';
import { LogoComponent } from './logo/logo.component';
import { MediaObjectModule } from './media-object/media-object.module';
import { MembershipBadgeComponent } from './membership-badge/membership-badge.component';
import { ModalModule } from './modal/modal.module';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { NotificationIndicatorComponent } from './notification-indicator/notification-indicator.component';
import { PictureComponent } from './picture/picture.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { RadioComponent } from './radio/radio.component';
import { RelativeTimeComponent } from './relative-time/relative-time.component';
import { SelectComponent } from './select/select.component';
import { SliderComponent } from './slider/slider.component';
import { SocialButtonsComponent } from './social-buttons/social-buttons.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { StarRatingComponent } from './star-rating/star-rating.component';
import { TabsComponent } from './tabs/tabs.component';
import { TextareaComponent } from './textarea/textarea.component';
import { ToggleComponent } from './toggle/toggle.component';
import { TooltipModule } from './tooltip/tooltip.module';
import { UI_CONFIG } from './ui.config';
import { UiConfig } from './ui.interface';
import { UpgradeTagComponent } from './upgrade-tag/upgrade-tag.component';
import { UserAvatarComponent } from './user-avatar/user-avatar.component';

@NgModule({
  declarations: [
    AlertComponent,
    BudgetComponent,
    ButtonComponent,
    DisplayCardComponent,
    CheckboxComponent,
    ContainerComponent,
    CurrencyComponent,
    CardComponent,
    CardHeaderLeftComponent,
    CardHeaderRightComponent,
    CardContentComponent,
    CardFooterLeftComponent,
    CardFooterRightComponent,
    EarningsComponent,
    EllipsisTextComponent,
    EmojiPickerComponent,
    EmojiPipe,
    FlagComponent,
    FileDragDropComponent,
    InputComponent,
    ListItemComponent,
    LoadingTextComponent,
    LogoComponent,
    MembershipBadgeComponent,
    MultiSelectComponent,
    NotificationIndicatorComponent,
    PictureComponent,
    ProgressBarComponent,
    RadioComponent,
    RelativeTimeComponent,
    SelectComponent,
    SliderComponent,
    SocialButtonsComponent,
    SpinnerComponent,
    StarRatingComponent,
    TabsComponent,
    TextareaComponent,
    ToggleComponent,
    UpgradeTagComponent,
    UserAvatarComponent,
  ],
  exports: [
    AlertComponent,
    BudgetComponent,
    ButtonComponent,
    CalloutModule,
    CardComponent,
    CheckboxComponent,
    ContainerComponent,
    CurrencyComponent,
    DisplayCardComponent,
    CardHeaderLeftComponent,
    CardHeaderRightComponent,
    CardContentComponent,
    CardFooterLeftComponent,
    CardFooterRightComponent,
    EarningsComponent,
    EllipsisTextComponent,
    EmojiPickerComponent,
    EmojiPipe,
    FlagComponent,
    FileDragDropComponent,
    HighlightTextModule,
    IconModule,
    InputComponent,
    LayoutModule,
    LinkModule,
    ListItemComponent,
    LoadingTextComponent,
    LogoComponent,
    MediaObjectModule,
    MembershipBadgeComponent,
    ModalModule,
    MultiSelectComponent,
    NotificationIndicatorComponent,
    OnlineStatusModule,
    PictureComponent,
    ProgressBarComponent,
    RadioComponent,
    ReactiveFormsModule,
    RelativeTimeComponent,
    SelectComponent,
    SliderComponent,
    SocialButtonsComponent,
    SpinnerComponent,
    StarRatingComponent,
    TabsComponent,
    TextareaComponent,
    ToggleComponent,
    TooltipModule,
    UpgradeTagComponent,
    UserAvatarComponent,
  ],
  imports: [
    CalloutModule,
    CommonModule,
    HighlightTextModule,
    IconModule,
    LayoutModule,
    LinkModule,
    MediaObjectModule,
    ModalModule,
    OnlineStatusModule,
    PerfectScrollbarModule,
    ReactiveFormsModule,
    RouterModule,
    TooltipModule,
  ],
  // /!\ DO NOT ADD PROVIDERS HERE
})
export class UiModule {
  static initialize(config: UiConfig): ModuleWithProviders {
    return {
      ngModule: UiModule,
      providers: [{ provide: UI_CONFIG, useValue: config }, LocalizedDateFns],
    };
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/ui/ui.module.ts